module.exports = __webpack_public_path__ + "static/media/Home.8674b74f.svg";